import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { LuCalendarClock, LuCalendarDays } from "react-icons/lu";
import { GrServices } from "react-icons/gr";
import { TbClock24, TbClockCheck } from "react-icons/tb";
import { MdApproval } from "react-icons/md";
import Testimonial from "../components/Sections/Testimonial";
import { animateScroll as scroll } from "react-scroll";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { RiRobot2Line } from "react-icons/ri";
import axios from "axios";

const RequirementForgeAgent = () => {
  const history = useHistory();

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const [isFlipped, setIsFlipped] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    website: "google.com",
    requirements: "",
    serviceType: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    requirements: Yup.string().required("Please describe your requirements"),
    serviceType: Yup.string().required("Please select a service type"),
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    // Note
    // (+) sign added in phone field onChange method

    setTimeout(() => {
      axios
        .post(
          "https://test.ct-n8n.ctserver.space/webhook/7b98e159-d91a-4569-90e4-c943579b4d18",
          values
        )
        .then((res) => {
          console.log("Response:", res.data);
          // Flip the card to show the thank you message
          setIsFlipped(true);
          setSubmitting(false);
          resetForm();
        })
        .catch((err) => console.error("Error:", err));
    }, 500);
  };

  const handleFlipBack = () => {
    setIsFlipped(false);
  };

  return (
    <>
      <Wrapper className="flex flexColumn">
        <HeroContainer>
          <ContentWrapper>
            <TextContent>
              <IconWrapper>
                <Icon>
                  <RiRobot2Line fontSize={44} />
                </Icon>
              </IconWrapper>
              <Title>RequirementForge AI</Title>
              <Description>
                RequirementForge AI is an intelligent assistant that streamlines
                the software development requirements gathering process. It
                collects essential information from users through natural
                conversation, including project details, technical
                specifications, and business goals, then transforms this input
                into comprehensive development requirements documentation
              </Description>
            </TextContent>
          </ContentWrapper>

          <CardContainer>
            <FlipCard isFlipped={isFlipped}>
              <CardFront>
                {/* <CardHeader>
                  <h4>Fill out the form below to get in touch with us</h4>
                </CardHeader> */}

                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, setFieldValue, values }) => (
                    <StyledForm>
                      <FormGroup>
                        <Label htmlFor="name">Name *</Label>
                        <Field
                          as={StyledField}
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Your name"
                        />
                        <FieldInfo>
                          We need your name to personalize our response and know
                          who to address.
                        </FieldInfo>
                        <StyledErrorMessage name="name" component="div" />
                      </FormGroup>

                      <FormGroup>
                        <Label htmlFor="email">Email *</Label>
                        <Field
                          as={StyledField}
                          type="email"
                          id="email"
                          name="email"
                          placeholder="Your email"
                        />
                        <FieldInfo>
                          We'll send updates and replies to this email. Make
                          sure it’s correct.
                        </FieldInfo>
                        <StyledErrorMessage name="email" component="div" />
                      </FormGroup>

                      <FormGroup>
                        <Label htmlFor="phone">Phone</Label>
                        <PhoneInput
                          country={"in"}
                          value={values.phone}
                          onChange={(phone) =>
                            setFieldValue("phone", `+${phone}`)
                          }
                          inputProps={{
                            name: "phone",
                            id: "phone",
                          }}
                          containerStyle={{ width: "100%" }}
                          inputStyle={{
                            width: "100%",
                            padding: "12px 15px 12px 50px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                            fontSize: "16px",
                            height: "auto",
                            transition: "border-color 0.3s",
                          }}
                          buttonStyle={{
                            borderRadius: "6px 0 0 6px",
                            border: "1px solid #e0e0e0",
                            backgroundColor: "#f5f5f5",
                          }}
                        />
                        <FieldInfo>
                          Your number helps us reach you quickly.
                        </FieldInfo>
                        <StyledErrorMessage name="phone" component="div" />
                      </FormGroup>

                      <FormGroup>
                        <Label htmlFor="serviceType">Service Type *</Label>
                        <Field
                          as={StyledSelect}
                          id="serviceType"
                          name="serviceType"
                        >
                          <option value="">Select a service</option>
                          <option value="web">Web Development</option>
                          <option value="mobile">Mobile App Development</option>
                          <option value="ai">AI Agent</option>
                          <option value="design">UI/UX Design</option>
                          <option value="other">Other</option>
                        </Field>
                        <FieldInfo>
                          Select the service you're interested in so we can
                          direct your request to the right team.
                        </FieldInfo>
                        <StyledErrorMessage
                          name="serviceType"
                          component="div"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label htmlFor="requirements">Requirement *</Label>
                        <Field
                          as={StyledTextarea}
                          id="requirements"
                          name="requirements"
                          placeholder="Describe your project requirements"
                        />
                        <FieldInfo>
                          Tell us what you’re looking for — the more details,
                          the better we can help.
                        </FieldInfo>
                        <StyledErrorMessage
                          name="requirements"
                          component="div"
                        />
                      </FormGroup>

                      <SubmitButton type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </SubmitButton>
                    </StyledForm>
                  )}
                </Formik>
              </CardFront>

              <CardBack>
                <ThankYouContainer>
                  <ThankYouIcon>✓</ThankYouIcon>
                  <h2>Thank You!</h2>
                  <p>
                    We've received your requirements and will contact you soon.
                  </p>
                  <BackButton onClick={handleFlipBack}>
                    Submit Another Request
                  </BackButton>
                </ThankYouContainer>
              </CardBack>
            </FlipCard>
          </CardContainer>
        </HeroContainer>
      </Wrapper>

      <DemoSampleWrapper className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Features</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <DemoSampleWrapperDiv>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuCalendarDays fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Lorem ipsum
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuCalendarClock fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Lorem ipsum
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <GrServices fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Lorem ipsum
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <TbClockCheck fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Lorem ipsum
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdApproval fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Lorem ipsum
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <TbClock24 fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Lorem ipsum
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua.
              </DemoFeatureDesc>
            </FeatureWrapper>
          </DemoSampleWrapperDiv>
        </div>
      </DemoSampleWrapper>

      {/* Testimonial */}
      <Testimonial />
    </>
  );
};

const Wrapper = styled.section`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 110px 30px 0px 30px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const HeroContainer = styled.section`
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  padding: 32px;
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
  min-width: 300px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 2;
`;

const IconWrapper = styled.div`
  position: relative;
  margin-bottom: 32px;
  @media (max-width: 860px) {
    display: none;
  }
`;

const Icon = styled.div`
  width: 70px;
  height: 70px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DemoSampleWrapper = styled.div`
  margin-top: 50px;
  padding: 50px 0px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const DemoSampleWrapperDiv = styled.div`
  width: 100%;
  max-width: 1220px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const FeatureWrapper = styled.div`
  width: 350px;
  height: 220px;
  text-align: left;
  padding: 20px 30px;
  margin: 30px 0px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.05) translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  }
`;

const DemoFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DemoFeatureIcon = styled.div`
  width: 30%;
  width: 60px;
  height: 60px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DemoFeatureTitle = styled.h3`
  width: 70%;
  padding: 10px 15px;
`;

const DemoFeatureDesc = styled.p`
  padding: 10px 0px;
`;

const CardContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  perspective: 1000px;
  padding: 20px;
`;

const FlipCard = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 1050px;
  max-height: 1200px;
  transition: transform 0.8s, height 0.8s;
  transform-style: preserve-3d;
  transform: ${(props) => (props.isFlipped ? "rotateY(180deg)" : "rotateY(0)")};
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 4px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 12px;

  @media (max-width: 768px) {
    min-height: 650px;
  }
`;

const CardSide = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  flex-direction: column;
`;

const CardFront = styled(CardSide)`
  background-color: #fff;
`;

const CardBack = styled(CardSide)`
  background-color: #7620ff;
  color: white;
  transform: rotateY(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const CardHeader = styled.div`
  margin-bottom: 25px;
  text-align: center;

  h2 {
    color: #0b093b;
    margin-bottom: 10px;
    font-size: 28px;
  }

  p {
    color: #707070;
    font-size: 16px;
  }
`;

// Form Styling
const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

const Label = styled.label`
  margin-bottom: 6px;
  font-weight: 500;
  color: #0b093b;
`;

const StyledField = styled.input`
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #7620ff;
    box-shadow: 0 0 0 2px rgba(118, 32, 255, 0.2);
  }
`;

const StyledTextarea = styled.textarea`
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 16px;
  min-height: 120px;
  resize: vertical;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #7620ff;
    box-shadow: 0 0 0 2px rgba(118, 32, 255, 0.2);
  }
`;

const StyledSelect = styled.select`
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 16px;
  background-color: white;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #7620ff;
    box-shadow: 0 0 0 2px rgba(118, 32, 255, 0.2);
  }
`;

const StyledPhoneInput = styled(PhoneInput)`
  .react-tel-input .form-control {
    width: 100%;
    padding: 12px 15px 12px 50px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 16px;
    height: auto;
    transition: border-color 0.3s;
  }

  .react-tel-input .form-control:focus {
    outline: none;
    border-color: #7620ff;
    box-shadow: 0 0 0 2px rgba(118, 32, 255, 0.2);
  }

  .react-tel-input .flag-dropdown {
    border-radius: 6px 0 0 6px;
    border: 1px solid #e0e0e0;
    background-color: #f5f5f5;
  }
`;

const FieldInfo = styled.p`
  font-size: 14px;
  line-height: 1.5;
  margin: 6px 0px;
  color: #0b093b;
`;

const StyledErrorMessage = styled(ErrorMessage)`
  color: #ff3860;
  font-size: 14px;
  margin-top: 5px;
`;

const SubmitButton = styled.button`
  background-color: #7620ff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  margin-top: 10px;

  &:hover {
    background-color: #6010e0;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #b794ff;
    cursor: not-allowed;
  }
`;

// Thank You Message Styling
const ThankYouContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  h2 {
    font-size: 32px;
    margin: 20px 0;
  }

  p {
    font-size: 18px;
    margin-bottom: 30px;
    max-width: 80%;
  }
`;

const ThankYouIcon = styled.div`
  width: 80px;
  height: 80px;
  background-color: white;
  color: #7620ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  margin-bottom: 20px;
`;

const BackButton = styled.button`
  background-color: white;
  color: #7620ff;
  border: none;
  border-radius: 6px;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  margin-top: 20px;

  &:hover {
    background-color: #f5f5f5;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export default RequirementForgeAgent;
